/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 10:21:42
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-23 11:25:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/tool/index.ts
 */
export const defaultData = {
  storeUuid: '1',
  uuid: null,
  collectionName: '',
  hasModified: false,
  seoSetting: {
    title: '',
    description: '',
    urlSlug: '',
    slugValid: true,
  },
  featuredImage: {
    uuid: '',
    fileName: '',
    url: '',
    size: '',
    width: '',
    height: '',
  },
  salesChannelProductUuids: [],
  products: [],
  loaded: false,
  collapseOpen: {
    CollectionInfo: true,
    SEOSetting: false,
    FeaturedImage: false,
    Products: false,
  },
  collectionNameError: '',
};
